import { type DetailedHTMLProps, forwardRef, type InputHTMLAttributes, type PropsWithChildren } from 'react';
import { type FieldError } from 'react-hook-form';
import styled from 'styled-components';

export type BaseFileInputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> &
	PropsWithChildren<{
		error?: FieldError;
	}>;

export const BaseFileInput = forwardRef<HTMLInputElement, BaseFileInputProps>(({ children, ...props }, ref) => (
	<>
		<S.Input {...props} id={props.id || 'hiddenFileInput'} ref={ref} type="file" />
		<div>{children}</div>
	</>
));

BaseFileInput.displayName = 'BaseFileInput';

namespace S {
	export const Input = styled.input``;
}
